const fontSizes = {
  text: '14px',
}

export default fontSizes
